export default __webpack_public_path__ + "static/media/left_arrow.96cfa795.svg";